




















import { Vue, Component, Watch } from 'vue-property-decorator'
import SessionGuestSignup from 'pages/attendee/SessionGuestSignup.vue'
import SessionInfo from 'components/attendee/session/SessionInfo.vue'
import api from 'src/assets/api/gql'
import AttendeeGuestSignupCodeFind from 'src/graphql/attendee_signup/AttendeeGuestSignupCodeFind.gql'
import { Session, SessionAttendee, Item, ItemTypeTopic } from 'src/graphql/types'

@Component({
  components: {
    SessionGuestSignup,
    SessionInfo
  }
})
export default class LayoutsAttendeeSessionGuest extends Vue {
  ItemTypeTopic = ItemTypeTopic
  loading = true
  session: Session | null = null
  attendee: SessionAttendee | null = null

  async created () {
    this.loading = true
    const code = this.$route.params.code.toUpperCase()
    this.session = await this.getSession(code) || null
    this.loading = false
  }

  async getSession (signupCode: string) {
    if (signupCode.length === 9 && signupCode.endsWith('S')) {
      const { data: { attendeeGuestSignupCodeFind } } = await api.query({
        query: AttendeeGuestSignupCodeFind,
        variables: { signupCode }
      })
      return attendeeGuestSignupCodeFind
    }
  }

  start (attendee: SessionAttendee) {
    if (attendee.responseSession && attendee.responseTopic) {
      attendee.data = {}
      attendee.responseTopic.data = {}
      attendee.responseSession.data = {}
      attendee.responseSession.chatMessages = []
      this.attendee = attendee
    }
  }

  exit () {
    this.attendee = null
  }
}
